import styled from 'styled-components'
import { color } from '../../../GlobalStyle'

export const ContainerInfo = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.cursor ? 'pointer' : 'default')};

  -webkit-box-shadow: 0 0 40px rgb(8 21 66 / 15%);
  box-shadow: 0 0 40px rgb(8 21 66 / 15%);
  padding: 15px;

  border-radius: 5px;
`

export const Text = styled.p`
  margin: 0;
  font-size: 16px;
`

export const Value = styled.p`
  font-weight: bold;
  margin: 0;
  font-size: 22px;
  color: ${color.brand};
  color: ${(props) => props.bgColor};
`
